import { render, staticRenderFns } from "./AppointmentEditPopup.vue?vue&type=template&id=8143264a"
import script from "./AppointmentEditPopup.vue?vue&type=script&lang=js"
export * from "./AppointmentEditPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports